import { useState } from "react";
import { withAppHOC } from "../../../hoc";
import PageHeading from "../../../components/PageHeader/PageHeader";
import OverlayLoader from "../../../components/OverlayLoader/OverlayLoader";
import { Grid, GridItem } from "../../../components/Grid";
import {
  FormContainer,
  Form,
  Fieldset,
  Label,
  TextInput,
  Dropdown,
  MessageBox,
  CreateButton,
  ResetButton,
} from "../../../components/FormElements";
import { StyledMicroButton } from "../../../components/Styled";
import API from "../../../api";
import { API_RESPONSE_TYPES, PERMISSION_TYPES } from "../../../constants";
import { getReturnUrl } from "../../../utils";

const SmsAPIConfigurationCreate = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [responseStatus, setResponseStatus] = useState("");
  const [responseMessage, setResponseMessage] = useState("");
  const [apiName, setApiName] = useState("");
  const [smsEndpoint, setSmsEndpoint] = useState("");
  const [smsBody, setSmsBody] = useState("");
  const [smsRequestMethod, setSmsRequestMethod] = useState("");
  const [smsResponseType, setSmsResponseType] = useState("");
  const [smsStatusKey, setSmsStatusKey] = useState("");
  const [smsSuccessValue, setSmsSuccessValue] = useState("");
  const [smsFailedValue, setSmsFailedValue] = useState("");
  const [smsRegards, setSmsRegards] = useState("");
  const [status, setStatus] = useState("");

  const resetResponseData = () => {
    setIsLoading(false);
    setResponseStatus("");
    setResponseMessage("");
  };

  const resetForm = () => {
    setApiName("");
    setSmsEndpoint("");
    setSmsRequestMethod("");
    setSmsBody("");
    setSmsResponseType("");
    setSmsStatusKey("");
    setSmsSuccessValue("");
    setSmsFailedValue("");
    setSmsRegards("");
    setStatus("");
  };

  const onSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setResponseStatus("");
    setResponseMessage("");
    const formData = {
      apiName,
      smsEndpoint,
      smsRequestMethod,
      smsBody,
      smsResponseType,
      smsStatusKey,
      smsSuccessValue,
      smsFailedValue,
      smsRegards,
      status,
    };
    API.post(`/configurations/sms-api`, formData)
      .then((response) => {
        const { status, message } = response.data;
        setResponseStatus(status);
        setResponseMessage(message);
        if (status === API_RESPONSE_TYPES.SUCCESS) {
          resetForm();
          setTimeout(() => {
            resetResponseData();
            window.location.href = getReturnUrl(PERMISSION_TYPES.CREATE);
          }, 3000);
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILED);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const addText = (setMethod, value) => {
    setMethod((currentValue) => currentValue + value);
  };

  return (
    <>
      <PageHeading {...props} />
      <FormContainer>
        <Form method="POST" action="#" onSubmit={onSubmit}>
          <Fieldset>
            <Label required>API Name</Label>
            <TextInput
              value={apiName}
              onChange={setApiName}
              placeholder="Please enter api name"
              disabled={isLoading}
            />
          </Fieldset>
          <Fieldset>
            <Label required>API Endpoint</Label>
            <TextInput
              value={smsEndpoint}
              onChange={setSmsEndpoint}
              placeholder="Please enter api endpoint"
              disabled={isLoading}
            />
          </Fieldset>
          <Fieldset>
            <Label required>Request Body</Label>
            <TextInput
              value={smsBody}
              onChange={setSmsBody}
              placeholder="Please enter request body"
              disabled={isLoading}
            />
            <StyledMicroButton
              disabled={isLoading}
              type="button"
              onClick={() => addText(setSmsBody, "{{{NUMBER}}}")}
            >
              Mobile Number
            </StyledMicroButton>
            <StyledMicroButton
              disabled={isLoading}
              type="button"
              onClick={() => addText(setSmsBody, "{{{MESSAGE}}}")}
            >
              Message
            </StyledMicroButton>
          </Fieldset>
          <Grid columns={"calc(50% - 10px) calc(50% - 10px)"}>
            <GridItem>
              <Fieldset>
                <Label required>Request Method</Label>
                <Dropdown
                  value={smsRequestMethod}
                  onChange={setSmsRequestMethod}
                  placeholder="Please select request method"
                  disabled={isLoading}
                  options={[
                    {
                      title: "-- SELECT API REQUEST METHOD --",
                      value: "",
                    },
                    {
                      title: "POST",
                      value: "POST",
                    },
                    {
                      title: "GET",
                      value: "GET",
                    },
                  ]}
                />
              </Fieldset>
            </GridItem>
            <GridItem>
              <Fieldset>
                <Label required>Response Type</Label>
                <Dropdown
                  value={smsResponseType}
                  onChange={setSmsResponseType}
                  placeholder="Please select response type"
                  disabled={isLoading}
                  options={[
                    {
                      title: "-- SELECT API RESPONSE TYPE --",
                      value: "",
                    },
                    {
                      title: "JSON",
                      value: "JSON",
                    },
                    {
                      title: "XML",
                      value: "XML",
                    },
                  ]}
                />
              </Fieldset>
            </GridItem>
          </Grid>
          <Grid
            columns={
              "calc(33.33% - 13.33px) calc(33.33% - 13.33px) calc(33.33% - 13.33px)"
            }
          >
            <GridItem>
              <Fieldset>
                <Label>Status Key</Label>
                <TextInput
                  value={smsStatusKey}
                  onChange={setSmsStatusKey}
                  placeholder="Please enter status key"
                  disabled={isLoading}
                />
              </Fieldset>
            </GridItem>
            <GridItem>
              <Fieldset>
                <Label>Success Value</Label>
                <TextInput
                  value={smsSuccessValue}
                  onChange={setSmsSuccessValue}
                  placeholder="Please enter success value"
                  disabled={isLoading}
                />
              </Fieldset>
            </GridItem>
            <GridItem>
              <Fieldset>
                <Label>Failure Value</Label>
                <TextInput
                  value={smsFailedValue}
                  onChange={setSmsFailedValue}
                  placeholder="Please enter failure value"
                  disabled={isLoading}
                />
              </Fieldset>
            </GridItem>
          </Grid>
          <Fieldset>
            <Label>Company Name ( Registered Firm Name )</Label>
            <TextInput
              value={smsRegards}
              onChange={setSmsRegards}
              placeholder="Please enter company name"
              disabled={isLoading}
            />
          </Fieldset>
          <Fieldset>
            <Label required>API Status</Label>
            <Dropdown
              value={status}
              onChange={setStatus}
              placeholder="Please select status"
              disabled={isLoading === true}
              options={[
                {
                  title: "-- SELECT API STATUS --",
                  value: "",
                },
                {
                  title: "Active",
                  value: "Active",
                },
                {
                  title: "Inactive",
                  value: "Inactive",
                },
              ]}
            />
          </Fieldset>
          {responseStatus && (
            <Fieldset>
              <MessageBox status={responseStatus} message={responseMessage} />
            </Fieldset>
          )}
          <Fieldset>
            <CreateButton disabled={isLoading} type="submit">
              Create
            </CreateButton>
            <ResetButton disabled={isLoading} type="button" onClick={resetForm}>
              Reset
            </ResetButton>
          </Fieldset>
        </Form>
        <OverlayLoader showLoader={isLoading} />
      </FormContainer>
    </>
  );
};

export default withAppHOC(SmsAPIConfigurationCreate);
